import React from 'react'
import { connect } from 'react-redux'
import { showModal } from '../../actions'
import Modal from '../Modal'

const INITIAL_STATE = {
  isOpen: false
};
class ModalRedux extends React.Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  render() {
    const { modal, showModal } = this.props;
    if (modal) {
      modal.isOpen = true;
      if (!modal.handleClose) {
        modal.handleClose = () => {
          showModal(null);
        };
      }
      if (!modal.onClick) {
        modal.onClick = () => {
          showModal(null);
        };
      }
    }
    return <Modal {...modal} />;
  }
}

const mapStateToProps = ({ componentReducer }) => {
  const { modal } = componentReducer;
  return {
    modal
  };
};

export default connect(mapStateToProps, { showModal })(ModalRedux);
